/* ============================================================
   NORTHSHEEP — COME BACK TO THE HIDE YOU CLICKED

   THE ONE PLACE THAT MOVES THE PAGE.

   Owner, 20 Sep 2026, after a day of this: "everytime you think you solved it
   it seems its just getting worse ... cant you just scan all my code or
   something and clean up without breaking functionality".

   They were right, and the count said so: sixteen places in the theme were
   writing the scroll position and fifteen were writing the page height, on
   five different schedules — a claim on <html>, a spacer div, a paint hold, a
   card-placing loop, a heartbeat, a mutation observer, and the browser's own
   restoration. Each fix repaired one and disturbed another. This file
   replaces all of them.

   WHAT ACTUALLY GOES WRONG, in one paragraph. Shopify caps a page at 50
   products, so a 96-card page is 48 rendered by the server and 48 fetched a
   moment later. Restore a position into the half-height document that exists
   in between and the browser clamps it to the end — the footer. Then the rest
   arrives, promo tiles insert above the reading position, and everything
   shifts again.

   THE TWO ANSWERS, AND THEY ARE SEPARATE.

     HEIGHT belongs to the server. main-collection-product-grid.liquid renders
     the rows the second batch will occupy, so the document is its full length
     before any script runs and there is nothing to clamp. No JavaScript is
     involved and nothing can race it.

     POSITION belongs to this loop, and it does not remember a pixel — a pixel
     stops meaning anything the moment something is inserted above it. It
     anchors to the CARD: every tick, the page is put wherever it has to be
     for that hide to sit exactly where it sat when the shopper tapped it. A
     promo inserting above is cancelled in the same tick, before it can be
     seen.

   WHY A TIMER AND NOT requestAnimationFrame. rAF is not called while a
   browser chooses not to paint — a loading page on a busy phone does exactly
   that, and an earlier version of this loop ran once and was never called
   again, leaving the page 241px out with nothing to correct it. rAF is used
   as WELL, because a correction made inside the frame that caused it is
   invisible, but the timer is what guarantees the loop survives.

   WHEN IT STOPS. On a deliberate scroll — touchmove, wheel or a key — because
   nothing is worse than a page that scrolls itself while someone is reading.
   Otherwise when the card has held still for a while and there is nothing
   left to load, or after three seconds, whichever comes first.

   touchMOVE, never touchSTART: a page opened with a back gesture has a finger
   on the glass before the first frame, and cancelling on touchstart killed
   every restore on a phone while leaving desktop working perfectly — which is
   exactly what the owner reported and what took longest to find.
   ============================================================ */
(function () {
  'use strict';
  if (window.__nsGridRestore) return;
  window.__nsGridRestore = true;

  var KEY = 'northsheep_grid_return';
  var VIEWS_KEY = 'northsheep_grid_returns';
  var MAX_AGE = 60 * 60 * 1000;

  /* The newest record, or - when that one belongs to another view - this
     view's own copy (ns-grid-return.js keeps one per view; audit, 4 Oct 2026,
     S5: Back through a second collection used to land at the top). A copy
     taken is made the newest record again, so every other reader sees it. */
  function read() {
    try {
      var s = JSON.parse(sessionStorage.getItem(KEY) || 'null');
      if (s && s.url === here()) return s;
      var own = (JSON.parse(sessionStorage.getItem(VIEWS_KEY) || '{}') || {})[here()];
      if (!own) return s;
      sessionStorage.setItem(KEY, JSON.stringify(own));
      return own;
    } catch (e) {
      return null;
    }
  }
  function clear() {
    try {
      sessionStorage.removeItem(KEY);
      var all = JSON.parse(sessionStorage.getItem(VIEWS_KEY) || '{}') || {};
      if (all[here()]) {
        delete all[here()];
        sessionStorage.setItem(VIEWS_KEY, JSON.stringify(all));
      }
    } catch (e) {}
  }
  function here() {
    return location.pathname + location.search;
  }

  /* The browser's own restoration is switched off on a return in Chromium
     124+ (which holds the first paint) and in WebKit (measured painting only
     once the page has parsed, and fighting this loop over 30px when left on)
     — the head of theme.liquid. There this loop places the first frame.
     Elsewhere it stays on: switched off with nothing holding the paint, the
     shopper saw the top of the page first, twice. Handing it back matters
     either way:
     it is a property of the HISTORY ENTRY, not of this page load, so leaving
     it off would break the next visit to this same entry — including the
     back-forward cache, where everything works without us. It is handed back
     on the way out, at pagehide; never at beforeunload or unload, which evict
     the page from that cache. */
  function handBack() {
    try {
      if ('scrollRestoration' in history && history.scrollRestoration !== 'auto') {
        history.scrollRestoration = 'auto';
      }
    } catch (e) {}
  }
  window.addEventListener('pagehide', handBack);

  /* ============================================================
     THE BACK-FORWARD CACHE: THE PAGE COMES BACK, THE POSITION DOES NOT.

     This is the case everything else in this file misses, and it is the one
     that was failing on the owner's iPhone all along.

     Measured on iOS Safari, 21 Sep 2026, from the collection page:

       persisted:YES  leftAt:1977  now:0>38>38>38>38>38>38>38>38>38>38

     Safari kept the document alive and handed it back — `persisted` is true,
     there is no reload, no flash, nothing to re-render. It simply did not put
     the scroll offset back: the page arrives at 0, settles at 38, which is
     the height of the announcement bar, and stays there. A shopper who was
     1,977px down is looking at the header.

     WHY NOTHING ELSE IN THIS FILE CATCHES IT. A restored page does not run
     its scripts again — no parse, no execution, no start(). The loop below
     ran once, when the document was first built, and is long finished. Every
     other path (a fresh load, a reload, a back that missed the cache) rebuilds
     the document and therefore re-runs everything, which is exactly why those
     measured perfectly while this one was broken and invisible.

     So the only thing that can act here is a listener registered earlier and
     kept alive with the page, which is what this is.

     IT AIMS AT THE PIXEL, NOT THE CARD. The document is not a re-render, it
     is the same document, down to the DOM nodes — nothing has moved, nothing
     has to be found again. The recorded offset is exact, and the card anchor
     would only add a way to be wrong.

     IT HOLDS, BRIEFLY. One scrollTo is not enough: something puts the page at
     38 after the restore, so a single correction at pageshow is simply undone.
     The position is re-asserted for a little over a second, then abandoned —
     and abandoned instantly if the shopper touches the screen, because a page
     that scrolls itself under a moving finger is worse than one that lands in
     the wrong place. Nothing is written while the offset is already right, so
     a browser that restores correctly never sees this run at all.
     ============================================================ */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;

    var s = read();
    if (!s || s.url !== here() || !s.y || s.y < 40) return;

    var target = s.y;
    var holding = true;
    function release() {
      if (!holding) return;
      holding = false;
      window.removeEventListener('touchmove', release);
      window.removeEventListener('wheel', release);
      window.removeEventListener('keydown', release);
    }
    window.addEventListener('touchmove', release, { passive: true });
    window.addEventListener('wheel', release, { passive: true });
    window.addEventListener('keydown', release);

    var until = Date.now() + 1200;
    (function hold() {
      if (!holding || Date.now() > until) {
        release();
        return;
      }
      var max = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
      var want = target > max ? max : target;
      /* A few pixels of slack: Safari reports fractional offsets while the
         URL bar is collapsing, and correcting those would fight the browser
         over something nobody can see. */
      if (Math.abs((window.pageYOffset || 0) - want) > 4) window.scrollTo(0, want);
      setTimeout(hold, 60);
    })();
  });

  function start() {
    var saved = read();
    if (!saved || saved.url !== here() || !saved.y || Date.now() - saved.ts > MAX_AGE) {
      handBack();
      return;
    }

    /* A RELOAD IS HELD TOO, BUT IT IS ANCHORED DIFFERENTLY.

       Both journeys get a lock, because Safari has no scroll anchoring and
       cannot be trusted to hold either one (owner, 21 Sep 2026: "i also want
       to lock for safari scroll height for back forth and reload"). What
       changes between them is WHAT is being aimed at.

       Coming BACK, the target is the card: the page may legitimately differ
       from the one that was left — a product hidden by curate, a filter
       still on — so a remembered pixel describes a document that no longer
       exists. The card is the thing the shopper actually recognises.

       RELOADING, the target is the pixel, and the card is exactly wrong.
       Measured: refreshing put the shopper 414px out, because the card
       anchor aims at the last hide they TAPPED, which is not where they were
       standing when they hit refresh. A reload re-renders the same URL with
       the same products in the same order, so the offset recorded on the way
       out is not an approximation of the right answer — it IS the right
       answer, to the pixel.

       Anything else (a fresh navigation, a link in) is not a return at all
       and must be left alone. */
    var isReload = false;
    try {
      var navEntry = (performance.getEntriesByType('navigation') || [])[0];
      var navType = navEntry ? navEntry.type : null;
      if (navType === 'reload') isReload = true;
      else if (navType && navType !== 'back_forward') return;
    } catch (e) {}

    var savedTop = typeof saved.top === 'number' ? saved.top : 0;
    var sel = saved.handle
      ? '[data-ns-card-handle="' + String(saved.handle).replace(/"/g, '\\"') + '"]'
      : null;

    /* Long enough to outlive window.load and the work that follows it on a
       slow phone. The loop is idle when the card is not moving, so a longer
       ceiling costs nothing; stopping too early costs the whole feature. */
    var deadline = Date.now() + 8000;
    var live = true;
    var steadySince = 0;
    var lastWant = -1;

    /* ONE PENDING TIMER AND ONE PENDING FRAME, NEVER MORE (audit, 23 Sep 2026).

       Every tick used to schedule BOTH a setTimeout and a requestAnimationFrame,
       and each of those, when it ran, scheduled both again — so the number of
       pending ticks doubled every frame. The `running` flag below only stops a
       tick re-entering itself; it never stopped two callbacks from being queued.
       Modelled in the page: 453 ticks in the first 160ms instead of 15, and
       doubling, each one reading scrollHeight and searching the document, until
       the page settled or the shopper touched it — on every back and every
       reload to a collection. The browser pane never saw it: hidden, it never
       fires animation frames, so there the loop only ever had its timer. */
    var timerId = 0;
    var frameId = 0;
    function schedule() {
      if (!timerId) {
        timerId = window.setTimeout(function () {
          timerId = 0;
          tick();
        }, 16);
      }
      if (!frameId && window.requestAnimationFrame) {
        frameId = window.requestAnimationFrame(function () {
          frameId = 0;
          tick();
        });
      }
    }

    function stop() {
      if (!live) return;
      live = false;
      if (timerId) window.clearTimeout(timerId);
      if (frameId && window.cancelAnimationFrame) window.cancelAnimationFrame(frameId);
      timerId = 0;
      frameId = 0;
      window.removeEventListener('touchmove', stopByTouch);
      window.removeEventListener('wheel', stopByWheel);
      window.removeEventListener('keydown', stopByKey);
      clear();
      handBack();
    }

    var stopByTouch = function () { stop(); };
    var stopByWheel = function () { stop(); };
    var stopByKey = function () { stop(); };
    window.addEventListener('touchmove', stopByTouch, { passive: true });
    window.addEventListener('wheel', stopByWheel, { passive: true });
    window.addEventListener('keydown', stopByKey);

    /* Where the page has to be for the card to sit where it sat. Falls back to
       the remembered offset while the card is still in the batch that has not
       arrived — the reserved rows make that a good answer in the meantime. */
    function wanted() {
      /* See the note by isReload: on a refresh the recorded offset is the
         answer, and the card anchor is the thing that was 414px wrong. */
      if (!isReload && sel) {
        var card = document.querySelector(sel);
        if (card) {
          var r = card.getBoundingClientRect();
          if (r.height > 0) return Math.round((window.pageYOffset || 0) + r.top - savedTop);
        }
      }
      return saved.y;
    }

    /* ---- SETTLED MEANS THE PAGE STOPPED CHANGING ----

       The loop used to call it settled when the CARD had not moved for 400ms
       and there was nothing left to fetch. Traced on a reload: it ran 38
       ticks, placed the card perfectly, and stopped at 1,958ms — and then
       something inserted about 800px above the card and it was gone again,
       with nothing watching.

       On this collection that something is the promo tiles, which re-place
       themselves after window.load. But the rule must not know that: another
       collection has no promos, and the same damage is done by the lazy
       batch, by the saved custom order being re-applied, or by anything added
       to this theme next year.

       So the question is not "has the card been still?" but "has the GRID
       been still?" — which is observable, costs one MutationObserver, and is
       true of every cause at once. Debounced at 60ms, the convention here,
       because a curate drag fires these every frame. */
    /* ---- AND THE FONTS HAVE TO HAVE LANDED ----

       The last cause, and the one that hid the longest, because it changes
       NOTHING in the DOM. When the web font swaps in, every product title
       re-measures; a title that fitted on one line in the fallback takes two
       in Cormorant, each card above the reading position grows a few pixels,
       and the whole grid below slides down.

       Measured across four reloads of the same spot: +841, +799, +756, +713
       pixels. A shrinking series, because each reload had more of the font
       cached — which is exactly what a font-driven reflow looks like, and is
       why a MutationObserver never saw it and why "the grid has been still"
       was not enough.

       document.fonts.ready settles when the browser has finished with every
       font it is going to use, so it is the precise answer rather than a
       longer timer. Browsers without it are no worse off than before. */
    var gridChangedAt = Date.now();
    var fontsDone = !document.fonts || !document.fonts.ready;
    if (!fontsDone) {
      document.fonts.ready.then(function () {
        fontsDone = true;
        gridChangedAt = Date.now();
      });
    }
    (function watchPage() {
      /* MAIN, not just the grid. Measured: the last thing to move this page
         inserted itself while the grid had been quiet, and watching only the
         grid missed it. Anything that changes the document above the reading
         position has the same effect, so the whole of main is watched — a
         childList observer on a page that is not changing costs nothing. */
      var host = document.getElementById('MainContent') || document.body;
      if (!host || !window.MutationObserver) return;
      new MutationObserver(function () {
        gridChangedAt = Date.now();
      }).observe(host, { childList: true, subtree: true });
    })();

    var running = false;
    function tick() {
      if (running) return; // the timer and rAF both call this
      running = true;
      try {
        if (!live || Date.now() > deadline) {
          stop();
          return;
        }

        var max = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
        var want = wanted();
        if (want > max) want = max;
        if (want < 0) want = 0;

        if (Math.abs((window.pageYOffset || 0) - want) > 1) {
          window.scrollTo(0, want);
        }

        /* FINISHED MEANS THE PAGE HAS FINISHED, NOT THAT IT PAUSED.

           This used to stop after 400ms of stability and nothing left to
           fetch. Measured on a reload: the loop settled at about 450ms, and
           then ns-collection-promos.js re-placed its four promo tiles on
           window.load — three of them above the reading position — and the
           card dropped 807px with nothing watching any more.

           So `load` is a precondition, not a detail. Everything that moves
           this page — the lazy batch, the promo tiles, the saved custom
           order, images settling — has happened by then. Waiting costs
           nothing, because the loop only writes when the card has actually
           moved. */
        var settled = Math.abs(want - lastWant) <= 1;
        lastWant = want;
        var complete =
          document.readyState === 'complete' &&
          /* A WHOLE SECOND OF STILLNESS, not 400ms. Traced on a cold
             reload: the page finished loading, the grid went quiet, the loop
             called it settled at 2,244ms — and the last insert arrived just
             after that and moved the card 824px with nothing watching. A
             second is long enough to cover a debounced placement that waits
             for window.load, and costs nothing: the loop only writes when the
             card has actually moved, so the extra time is spent idle. */
          fontsDone &&
          Date.now() - gridChangedAt > 1000 &&
          (!window.NsLazyPages || NsLazyPages.isComplete());
        if (settled && complete) {
          if (!steadySince) steadySince = Date.now();
          if (Date.now() - steadySince > 400) {
            stop();
            return;
          }
        } else {
          steadySince = 0;
        }

        schedule();
      } finally {
        running = false;
      }
    }

    tick();
  }

  /* DOMContentLoaded, not sooner. This file itself loads synchronously,
     straight after the grid, so its pageshow listener is attached early; but
     the lazy loader it asks about is deferred, and an earlier version started
     too early and read a loader that did not exist yet (harmless now: the
     loop cannot call the page settled before window.load, by which time every
     deferred file has run). See begin() below for the one earlier start. */
  /* STARTED EARLY WHERE THE BROWSER HOLDS THE FIRST PAINT. On a Chromium
     return the head switches the browser's own restore off and the inline
     call just before #ns-page-end (theme.liquid) starts this there — the
     page has parsed, nothing is painted yet, so the loop's first tick places
     the first frame. Everywhere else it starts at DOMContentLoaded as before.
     Once only, whichever comes first. */
  var begun = false;
  function begin() {
    if (begun) return;
    begun = true;
    start();
  }
  window.__nsGridRestoreNow = begin;
  if (document.readyState === 'complete') begin();
  else document.addEventListener('DOMContentLoaded', begin);
})();
